import { useTranslation as useI18nTranslation } from 'react-i18next';

/**
 * Hook personnalisé pour les traductions
 * Encapsule react-i18next et ajoute des fonctionnalités utiles
 */
export const useTranslation = (namespace = 'translation') => {
  const { t, i18n } = useI18nTranslation(namespace);

  /**
   * Change la langue de l'application
   * @param {string} language - Code de la langue (fr, en, etc.)
   */
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  /**
   * Obtient la langue actuelle
   * @returns {string} Code de la langue actuelle
   */
  const getCurrentLanguage = () => {
    return i18n.language;
  };

  /**
   * Vérifie si une langue est supportée
   * @param {string} language - Code de la langue à vérifier
   * @returns {boolean} True si la langue est supportée
   */
  const isLanguageSupported = (language) => {
    return i18n.options.supportedLngs.includes(language);
  };

  /**
   * Obtient la liste des langues supportées
   * @returns {string[]} Liste des codes de langues supportées
   */
  const getSupportedLanguages = () => {
    return i18n.options.supportedLngs.filter(lng => lng !== 'cimode');
  };

  /**
   * Vérifie si i18n est prêt (traductions chargées)
   * @returns {boolean} True si i18n est prêt
   */
  const isReady = () => {
    return i18n.isInitialized;
  };

  return {
    t,
    i18n,
    changeLanguage,
    getCurrentLanguage,
    isLanguageSupported,
    getSupportedLanguages,
    isReady,
    // Propriétés utiles
    currentLanguage: getCurrentLanguage(),
    supportedLanguages: getSupportedLanguages(),
    ready: isReady()
  };
};

export default useTranslation;